"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { dropdownRecipe } from '../../recipes/dropdown.mjs';

const Content = forwardRef(
  ({ children, className, ...props }, ref) => {
    const { content } = dropdownRecipe();
    return /* @__PURE__ */ jsx("div", { ref, className: clsx("flex", content, className), ...props, children });
  }
);

export { Content };
